module.exports = __webpack_public_path__ + "static/media/July_2026_5.ef3555f0.webp";